var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { IconClose, IconMoreInfo, IconTickMark, IconWarning, IconWarningAlt } from "../../icons";
import Typography from "../Typography";
var icons = {
    neutral: _jsx(IconMoreInfo, {}),
    informative: _jsx(IconMoreInfo, {}),
    alert: _jsx(IconWarningAlt, {}),
    warning: _jsx(IconWarning, {}),
    positive: _jsx(IconTickMark, {}),
};
export var InlineNotification = function (_a) {
    var _b = _a.variant, variant = _b === void 0 ? "neutral" : _b, description = _a.description, title = _a.title, actionName = _a.actionName, actionHandler = _a.actionHandler, _c = _a.closable, closable = _c === void 0 ? false : _c, customIcon = _a.customIcon;
    var isClosable = !!closable;
    var _d = useState(true), isVisible = _d[0], setIsVisible = _d[1];
    var handleClose = function () {
        setIsVisible(false);
    };
    if (!isVisible)
        return null;
    var ActionDesc = actionName ? (_jsx("span", __assign({ className: "mex-inline-notification__action", onClick: actionHandler }, { children: actionName }))) : null;
    var icon = customIcon ? customIcon : icons[variant || "neutral"];
    return (_jsxs("div", __assign({ className: "mex-inline-notification ".concat(variant || "neutral") }, { children: [_jsx("div", __assign({ className: "mex-inline-notification__icon-wrapper" }, { children: icon })), _jsxs("div", __assign({ className: "mex-inline-notification__content" }, { children: [title && (_jsx("h4", __assign({ className: "mex-inline-notification__title" }, { children: _jsx(Typography, __assign({ variant: "body02Semibold" }, { children: title })) }))), _jsx("p", __assign({ className: "mex-inline-notification__description" }, { children: description && _jsx(Typography, __assign({ variant: "body02Regular" }, { children: description })) })), ActionDesc && (_jsx("div", __assign({ className: "mex-inline-notification__action" }, { children: _jsx(Typography, __assign({ variant: "body02Semibold" }, { children: ActionDesc })) })))] })), isClosable && _jsx(IconClose, { className: "mex-inline-notification__close", onClick: handleClose })] })));
};
export default InlineNotification;
